import styled from 'styled-components';

export const List = styled.ul`
  background: ${({ theme }) => theme.color.background.neutral.default};
  margin: ${({ theme }) => theme.spacing.km0};
  list-style: none;
  overflow-y: auto;
  padding: ${({ theme }) => theme.spacing.km0};
  transition: all 0.2s cubic-bezier(0.65, 0, 0.35, 1);
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing.km5};

  &::-webkit-scrollbar {
    display: none;
  }

  > div > div > div:last-child {
    margin-bottom: ${({ theme }) => theme.spacing.km10};
  }
`;
